import * as React from "react";
import type { SVGProps } from "react";
const SvgCloud04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M4.8 17.105a4.85 4.85 0 0 1-2.4-4.192c0-2.196 1.45-4.05 3.437-4.643C6.874 5.874 9.244 4.2 12 4.2c3.422 0 6.247 2.58 6.666 5.917a3.87 3.87 0 0 1 2.934 3.764c0 1.345-.68 2.53-1.713 3.224M8.4 19.8v-6m8.4 6v-6m-4.2 6v-6"
    />
  </svg>
);
export default SvgCloud04;
